import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const AcceptableUsePolicy = () => {
    const theme = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ color: theme.palette.blue[900], fontWeight: 600 }}>
                    Acceptable Use Policy
                </Typography>

                <Typography variant="subtitle1" sx={{ mb: 4, color: theme.palette.grey[600] }}>
                    Last Updated: January 31, 2025
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            1. Purpose
                        </Typography>
                        <Typography paragraph>
                            This Acceptable Use Policy outlines the permitted uses and prohibited activities when using apply-bridge's services. By using our service, you agree to comply with this policy.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            2. Permitted Use
                        </Typography>
                        <Typography paragraph>
                            apply-bridge's services may be used for:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Sending legitimate job application emails
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Managing professional follow-up communications
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Tracking job application status
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Storing and managing job-search related content
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            3. Prohibited Activities
                        </Typography>
                        <Typography paragraph>
                            Users are strictly prohibited from:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Using the service for spam or unsolicited mass emails
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Sending harassing, abusive, or threatening communications
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Uploading malicious content or malware
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Impersonating others or providing false information
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Attempting to gain unauthorized access to other users' accounts
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Using the service for any illegal activities
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Interfering with or disrupting the service or servers
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            4. Content Guidelines
                        </Typography>
                        <Typography paragraph>
                            All content submitted to apply-bridge must:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Be truthful and accurate
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Respect intellectual property rights
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Not contain discriminatory or offensive material
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Not violate any applicable laws or regulations
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            5. Email Usage
                        </Typography>
                        <Typography paragraph>
                            Users must:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Maintain professional communication standards
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Respect recipient preferences and opt-out requests
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Not exceed reasonable email frequency limits
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Only use the service for legitimate job applications
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            6. System and Network Security
                        </Typography>
                        <Typography paragraph>
                            Users are prohibited from:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Attempting to probe, scan, or test system vulnerabilities
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Attempting to breach or circumvent security measures
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Using any automated systems or scripts without permission
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            7. Enforcement
                        </Typography>
                        <Typography paragraph>
                            apply-bridge reserves the right to:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Monitor service usage for policy compliance
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Investigate potential policy violations
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Suspend or terminate accounts violating this policy
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Report illegal activities to appropriate authorities
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            8. Reporting Violations
                        </Typography>
                        <Typography paragraph>
                            Users should report suspected violations of this policy to info@apply-bridge.com. Please provide detailed information about the suspected violation and any supporting evidence.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            9. Policy Updates
                        </Typography>
                        <Typography paragraph>
                            apply-bridge reserves the right to modify this policy at any time. Users will be notified of significant changes, and continued use of the service constitutes acceptance of the updated policy.
                        </Typography>


                    </section>
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800], fontWeight: 600 }}>
                            Contact Information
                        </Typography>
                        <Typography>BIZZENCE WEBTECH PRIVATE LIMITED</Typography>
                        <Typography>Fl No203 Akshar DivyaApt, Aagar Takli Upnagar</Typography>
                        <Typography>Nashik Road, Nashik, Maharashtra 422101</Typography>
                        <Typography>India</Typography>
                        <Typography>Phone: (+91)7972305727</Typography>
                        <Typography>Email: info@apply-bridge.com</Typography>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default AcceptableUsePolicy;